module.exports = __webpack_public_path__ + "static/media/disabledStartIcon.7f21e56f.svg";